import { render, staticRenderFns } from "./MatchingList.vue?vue&type=template&id=7795edb6&scoped=true&"
import script from "./MatchingList.vue?vue&type=script&lang=ts&"
export * from "./MatchingList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7795edb6",
  null
  
)

export default component.exports